






import { Component, Vue } from 'vue-property-decorator'

@Component
export default class GreenPanel extends Vue {

    get componentClass() {
        return {
            'green-panel': true,
        }
    }
}


